module.exports = __webpack_public_path__ + "static/img/12.877d53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/12.png
// module id = /MtM
// module chunks = 0